import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useServices } from 'index';
import { AdminModulesSortPayload } from 'types/admin/modulesV2';

export const useSortModulesV2 = () => {
  const service = useServices().moduleListV2Service;
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: AdminModulesSortPayload) => service.sortModules(payload),
    onSuccess: async () => queryClient.invalidateQueries({ queryKey: ['adminModuleListV2'] }),
  });
};
